/* eslint-disable react/forbid-elements */
import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';

type DropzoneMaxSizeMessageProps = {
    maxSizeMb: number;
    fileExtension: string;
};

export function DropzoneMaxSizeMessage({ maxSizeMb, fileExtension }: DropzoneMaxSizeMessageProps) {
    const translate = useTranslate();

    return <div className="fs14 fw200">{translate('survey.maxFileSizeExplanation', fileExtension, maxSizeMb.toString())}</div>;
}
